import styled from 'styled-components';

export default function AppSpinner(props) {
  const {
    children,
    rps = 2,
  } = props;

  return (
    <Spinner rps={rps}>{children}</Spinner>
  );
}

const Spinner = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  -webkit-transform-origin: 50% 50%;
  transform-origin:50% 50%;
  -ms-transform-origin:50% 50%; /* IE 9 */
  -webkit-animation: spin ${(props) => props.rps}s infinite linear;
  -moz-animation: spin ${(props) => props.rps}s infinite linear;
  -o-animation: spin ${(props) => props.rps}s infinite linear;
  animation: spin ${(props) => props.rps}s infinite linear;

  @-moz-keyframes spin {
    from {
      -moz-transform: rotate(0deg);
    }
    to {
      -moz-transform: rotate(360deg);
    }
  }

  @-webkit-keyframes spin {
    from {
      -webkit-transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
